import * as base from './base.js'
const make = 'admin/api/make'

const obj = base.setBaseUrl('make', make)
const a = Object.assign(obj)
export default a
